// PreviewTester/components/Tour/TourModal.js
import React from 'react';

const TourModal = ({
  isOpen,
  onClose,
  onNext,
  onSkip,
  title,
  description,
  icon = '🚀',
  buttonText = 'Next',
  isLast = false,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.6)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backdropFilter: 'blur(4px)',
      animation: 'fadeIn 0.3s ease',
    }}>
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: scale(0.95); }
            to { opacity: 1; transform: scale(1); }
          }
          @keyframes pulse-glow {
            0% { box-shadow: 0 0 0 0 rgba(66, 153, 225, 0.4); }
            70% { box-shadow: 0 0 0 15px rgba(66, 153, 225, 0); }
            100% { box-shadow: 0 0 0 0 rgba(66, 153, 225, 0); }
          }
        `}
      </style>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: '32px 40px',
        maxWidth: '480px',
        width: '90%',
        maxHeight: '90vh',
        overflow: 'auto',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        position: 'relative',
      }}>
        {/* Close/Skip button */}
        <button
          onClick={onSkip}
          style={{
            position: 'absolute',
            top: '12px',
            right: '16px',
            background: 'transparent',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            color: '#a0aec0',
            transition: 'color 0.2s',
          }}
          onMouseEnter={(e) => e.target.style.color = '#4a5568'}
          onMouseLeave={(e) => e.target.style.color = '#a0aec0'}
        >
          ✕
        </button>

        {/* Icon */}
        <div style={{
          fontSize: '48px',
          textAlign: 'center',
          marginBottom: '12px',
          animation: 'pulse-glow 2s infinite',
        }}>
          {icon}
        </div>

        {/* Title */}
        <h2 style={{
          fontSize: '22px',
          fontWeight: '700',
          color: '#2d3748',
          textAlign: 'center',
          margin: '0 0 8px 0',
        }}>
          {title}
        </h2>

        {/* Description */}
        <p style={{
          fontSize: '15px',
          color: '#4a5568',
          textAlign: 'center',
          lineHeight: '1.6',
          margin: '0 0 20px 0',
        }}>
          {description}
        </p>

        {/* Custom content */}
        {children && (
          <div style={{ marginBottom: '20px' }}>
            {children}
          </div>
        )}

        {/* Progress dots */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '6px',
          marginBottom: '16px',
        }}>
          {/* This will be filled by parent */}
        </div>

        {/* Buttons */}
        <div style={{
          display: 'flex',
          gap: '10px',
          justifyContent: 'center',
        }}>
          {!isLast && (
            <button
              onClick={onSkip}
              style={{
                padding: '10px 24px',
                backgroundColor: 'transparent',
                color: '#718096',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.2s',
              }}
              onMouseEnter={(e) => { e.target.style.backgroundColor = '#f7fafc'; }}
              onMouseLeave={(e) => { e.target.style.backgroundColor = 'transparent'; }}
            >
              Skip Tour
            </button>
          )}
          <button
            onClick={isLast ? onClose : onNext}
            style={{
              padding: '10px 32px',
              backgroundColor: isLast ? '#48bb78' : '#4299e1',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = isLast ? '#38a169' : '#3182ce';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = isLast ? '#48bb78' : '#4299e1';
            }}
          >
            {isLast ? '🎉 Got it!' : buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TourModal;